import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import {
  DomSanitizer,
  Meta,
  SafeHtml,
  Title,
  TransferState,
  makeStateKey,
} from '@angular/platform-browser';
import { PostsDAO } from '../../core/services/dao/postsDAO';
import { isPlatformServer } from '@angular/common';
import { getExtension } from '../../core/pure-functions/upload/image-upload-helper';
import { Post } from 'anchor-shared/lib/model/entity/posts';

const DATA_KEY = makeStateKey<any>('post-renderer-data-state');

@Component({
  selector: 'app-post-renderer',
  templateUrl: './post-renderer.component.html',
  styleUrls: ['./post-renderer.component.scss'],
})
export class PostRendererComponent implements OnInit {
  safeSeoHtml: SafeHtml;

  constructor(
    private readonly postsDAO: PostsDAO,
    private router: Router,
    private sanitizer: DomSanitizer,
    private title: Title,
    private meta: Meta,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    console.log('from the PRC');
  }

  ngOnInit(): void {
    // this.loadAsyncData();
    this.loadWebComponentScripts();

    let serverPost: Post = this.transferState.get(DATA_KEY, null);
    if (!serverPost && isPlatformServer(this.platformId)) {
      console.log('isPlatformServer', 'calling get post for: ');
      console.log('url: ', this.router.url);
      this.postsDAO
        .getPost(this.router.url.split('?')[0])
        .pipe(take(1))
        .subscribe((post) => {
          serverPost = post;
          console.log('serverPost id: ', serverPost.id);
          this.safeSeoHtml = this.sanitizer.bypassSecurityTrustHtml(
            serverPost.content,
          );
          this.transferState.set(DATA_KEY, serverPost);
          this.setTags(
            serverPost.metaTitle,
            serverPost.metaDescription,
            serverPost.metaImage,
          );
        });
    } else {
      this.setTags(
        serverPost.metaTitle,
        serverPost.metaDescription,
        serverPost.metaImage,
      );
      this.safeSeoHtml = this.sanitizer.bypassSecurityTrustHtml(
        serverPost.content,
      );
      this.setAccordionClickListener();
    }
  }

  private loadWebComponentScripts(): void {
    // let script = this._renderer2.createElement('script');
    // script.type = `application/ld+json`;
    // script.text = `
    //         {
    //             "@context": "https://schema.org"
    //             /* your schema.org microdata goes here */
    //         }
    //     `;
    //
    // this._renderer2.appendChild(this._document.body, script);
  }

  // private loadAsyncData(): void {
  //   this.postsDAO
  //     .getPost(this.router.url)
  //     .pipe(take(1))
  //     .subscribe((htmlContent) => {
  //       console.log(htmlContent);
  //       this.safeSeoHtml = this.sanitizer.bypassSecurityTrustHtml(
  //         htmlContent.content,
  //       );
  //       this.setTags();
  //       this.setAccordionClickListener();
  //     });
  // }

  private setAccordionClickListener(): void {
    setTimeout(() => {
      const accordion = document.querySelectorAll('.bsolp__faq-accordion');
      accordion.forEach((accordion) => {
        accordion.addEventListener('click', () => {
          accordion.classList.toggle('active__accordion');
        });
      });
    }, 2000);
  }

  private setTags(title: string, description: string, image: string): void {
    this.title.setTitle(title);
    this.meta.addTag({
      property: 'description',
      content: description,
    });

    // twitter
    this.meta.addTag({
      property: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.addTag({
      property: 'twitter:title',
      content: title,
    });
    this.meta.addTag({
      property: 'twitter:description',
      content: description,
    });
    this.meta.addTag({
      property: 'twitter:image',
      content: image,
    });

    // object graph
    this.meta.addTag({
      property: 'og:site_name',
      content: 'Anchor',
    });
    this.meta.addTag({
      property: 'og:locale',
      content: 'en_US',
    });
    this.meta.addTag({
      property: 'og:title',
      content: title,
    });
    this.meta.addTag({
      property: 'og:type',
      content: 'anchor:project',
    });
    this.meta.addTag({
      property: 'og:description',
      content: description,
    });
    this.meta.addTag({
      property: 'og:url',
      content: window.location.href,
    });
    this.meta.addTag({
      property: 'og:image',
      content: image,
    });
    if (image) {
      this.meta.addTag({
        property: 'og:image:type',
        content: 'image/' + getExtension(image),
      });
    }
  }
}
